var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("columnNames")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-custom-language-select", {
                            model: {
                              value: _vm.lang,
                              callback: function ($$v) {
                                _vm.lang = $$v
                              },
                              expression: "lang",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("salenr") },
                            model: {
                              value:
                                _vm.columnNames.SaleNr.Translations[_vm.lang],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.SaleNr.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression:
                                "columnNames.SaleNr.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("date") },
                            model: {
                              value:
                                _vm.columnNames.Date.Translations[_vm.lang],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.Date.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression: "columnNames.Date.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("total") },
                            model: {
                              value:
                                _vm.columnNames.Total.Translations[_vm.lang],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.Total.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression:
                                "columnNames.Total.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("paid") },
                            model: {
                              value:
                                _vm.columnNames.Paid.Translations[_vm.lang],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.Paid.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression: "columnNames.Paid.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("interest") },
                            model: {
                              value:
                                _vm.columnNames.Interest.Translations[_vm.lang],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.Interest.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression:
                                "columnNames.Interest.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("cost") },
                            model: {
                              value:
                                _vm.columnNames.Cost.Translations[_vm.lang],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.Cost.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression: "columnNames.Cost.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("totalOpen") },
                            model: {
                              value:
                                _vm.columnNames.TotalOpen.Translations[
                                  _vm.lang
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.TotalOpen.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression:
                                "columnNames.TotalOpen.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("expirationDate"),
                            },
                            model: {
                              value:
                                _vm.columnNames.ExpirationDate.Translations[
                                  _vm.lang
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.columnNames.ExpirationDate.Translations,
                                  _vm.lang,
                                  $$v
                                )
                              },
                              expression:
                                "columnNames.ExpirationDate.Translations[lang]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }